function HomePage() {
  return (
    <main>
      Use the URL you were provided with.
    </main>
  );
}

export default HomePage;
